import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class LocalStorageService {
    public set(key: string, value: any): void {
        if (typeof value === 'object') {
            localStorage.setItem(key, JSON.stringify(value));
        } else {
            localStorage.setItem(key, String(value));
        }
    }

    public get<T>(key: string): T | null {
        const item = localStorage.getItem(key);
        if(!item) return null;

        try {
            return JSON.parse(item) as T;
        } catch {
            return item as unknown as T;
        }
    }

    public remove(key: string): void {
        if(localStorage.getItem(key)){
            localStorage.removeItem(key);
        }
    }

    public clear(): void {
        localStorage.clear();
    }
}